// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const loadTranslations = async () => {
  try {
    // Tải các file JSON từ thư mục public
    const [viResponse, enResponse] = await Promise.all([
      fetch("/media/locales/vi/translation.json"),
      fetch("/media/locales/en/translation.json"),
    ]);

    const [viTranslation, enTranslation] = await Promise.all([
      viResponse.json(),
      enResponse.json(),
    ]);

    // Khởi tạo i18n
    i18n.use(initReactI18next).init({
      resources: {
        vi: { translation: viTranslation },
        en: { translation: enTranslation },
      },
      lng: "vi", // Ngôn ngữ mặc định
      fallbackLng: "vi",
      interpolation: {
        escapeValue: false, // React đã bảo vệ chống XSS
      },
    });
  } catch (error) {
    console.log("Error loading translations:", error);
  }
};

loadTranslations();

export default i18n;
